"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));

var _TextInputPropTypes = _interopRequireDefault(require("../TextInput/TextInputPropTypes"));

var _AutoSuggestList = _interopRequireDefault(require("./AutoSuggestList"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var AutoSuggestInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AutoSuggestInput, _Component);

  function AutoSuggestInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AutoSuggestInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AutoSuggestInput).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInvalid", function (evt) {
      evt.preventDefault();
      var onInvalid = _this.props.onInvalid;

      if (onInvalid) {
        onInvalid(evt.currentTarget.validity);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInputChange", function (evt) {
      _this.setState({
        value: evt.target.value
      });

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(evt);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInputKeyDown", function (evt) {
      switch (evt.which) {
        case 40:
          _this._nextSuggest(evt);

          break;

        case 38:
          _this._previousSuggest(evt);

          break;

        case 13:
          _this._selectSuggest(evt);

          break;

        case 27:
          _this._hideSuggests(evt);

          break;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInputFocus", function () {
      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus();
      }

      _this.setState({
        suggestionsHidden: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInputBlur", function () {
      if (!_this.state.ignoreBlur) {
        _this._hideSuggests();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onSuggestionMouseDown", function () {
      _this.setState({
        ignoreBlur: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onSuggestionMouseOut", function () {
      _this.setState({
        ignoreBlur: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onSelectSuggestion", function (_ref) {
      var _ref$suggestion = _ref.suggestion,
          suggestion = _ref$suggestion === void 0 ? false : _ref$suggestion;
      var onSuggestionSelect = _this.props.onSuggestionSelect;
      var selectedSuggestion = suggestion;

      if (!selectedSuggestion) {
        selectedSuggestion = {};
        selectedSuggestion.label = _this.state.value;
      }

      _this.setState({
        suggestionsHidden: true,
        value: selectedSuggestion.label,
        inputKey: (0, _v.default)()
      });

      onSuggestionSelect(selectedSuggestion);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onClear", function () {
      var onClear = _this.props.onClear;

      _this.setState({
        value: '',
        inputKey: (0, _v.default)()
      });

      if (onClear) {
        onClear();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_selectSuggest", function (evt) {
      evt.preventDefault();

      _this._onSelectSuggestion({
        suggestion: _this.state.activeSuggestion
      });
    });
    var defaultValue = props.defaultValue;
    _this.state = {
      suggestionsHidden: true,
      ignoreBlur: false,
      value: defaultValue || '',
      activeSuggestion: null,
      inputKey: (0, _v.default)()
    };
    return _this;
  }

  (0, _createClass2.default)(AutoSuggestInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var suggestions = this.props.suggestions;

      this._input.node.addEventListener('invalid', this._onInvalid);

      if (suggestions.length) {
        this._showSuggests();
      } else {
        this._hideSuggests();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          suggestions = _this$props.suggestions,
          autoActivateFirstSuggest = _this$props.autoActivateFirstSuggest;
      var value = this.state.value;
      var prevSuggestions = prevProps.suggestions;

      if (prevState.value !== value) {
        if (!value) {
          this._input.node.focus();
        }
      }

      if (!(0, _isEqual.default)(prevSuggestions, suggestions)) {
        if (suggestions && suggestions.length) {
          this._showSuggests();

          if (autoActivateFirstSuggest) {
            this._activateSuggest({
              direction: 'next'
            });
          }
        } else {
          this._hideSuggests();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._input.node.removeEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "_nextSuggest",
    value: function _nextSuggest() {
      this._activateSuggest({
        direction: 'next',
        isArrowPress: true
      });
    }
  }, {
    key: "_previousSuggest",
    value: function _previousSuggest() {
      this._activateSuggest({
        direction: 'prev',
        isArrowPress: true
      });
    }
  }, {
    key: "_showSuggests",
    value: function _showSuggests() {
      if (this.state.suggestionsHidden) {
        this.setState({
          suggestionsHidden: false
        });
      }
    }
  }, {
    key: "_hideSuggests",
    value: function _hideSuggests() {
      var onBlur = this.props.onBlur;

      if (onBlur) {
        onBlur();
      }

      if (!this.state.suggestionsHidden) {
        this.setState({
          suggestionsHidden: true
        });
      }
    }
  }, {
    key: "_activateSuggest",
    value: function _activateSuggest(_ref2) {
      var direction = _ref2.direction,
          _ref2$isArrowPress = _ref2.isArrowPress,
          isArrowPress = _ref2$isArrowPress === void 0 ? false : _ref2$isArrowPress;
      var suggestions = this.props.suggestions;
      var activeSuggestion = this.state.activeSuggestion;
      var suggestionsCount = suggestions.length - 1;
      var next = direction === 'next';
      var newState = {};
      var newActiveSuggestion = null;
      var newIndex = 0;
      var i = 0;

      for (i; i <= suggestionsCount; i++) {
        if (suggestions[i] === activeSuggestion) {
          newIndex = next ? i + 1 : i - 1;
        }
      }

      if (!activeSuggestion) {
        newIndex = next ? 0 : suggestionsCount;
      }

      if (newIndex < 0) {
        newIndex = suggestionsCount;
      } else if (newIndex > suggestionsCount) {
        newIndex = 0;
      }

      if (newIndex >= 0 && newIndex <= suggestionsCount) {
        newActiveSuggestion = suggestions[newIndex];
      }

      newState.activeSuggestion = newActiveSuggestion;

      if (isArrowPress) {
        newState.value = newActiveSuggestion ? newActiveSuggestion.label : '';
      }

      this.setState(newState);
    }
    /**
     * Getter for the input DOM element.
     *
     * @public
     * @returns {Element} - The input element.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          suggestions = _this$props2.suggestions,
          suggestionBoxFooter = _this$props2.suggestionBoxFooter,
          additionalInputProps = _this$props2.additionalInputProps,
          textInputProps = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "suggestions", "suggestionBoxFooter", "additionalInputProps"]);
      var _this$state = this.state,
          value = _this$state.value,
          inputKey = _this$state.inputKey,
          activeSuggestion = _this$state.activeSuggestion,
          suggestionsHidden = _this$state.suggestionsHidden;
      var classes = (0, _classnames.default)('AutoSuggestInput', {
        'AutoSuggestInput-suggestions-active': !suggestionsHidden
      }, {
        'AutoSuggestInput-no-suggestions': !suggestions || !suggestions.length
      }, className);
      var newAdditionalInputProps = (0, _objectSpread2.default)({}, additionalInputProps, {
        onKeyDown: this._onInputKeyDown,
        autoComplete: 'off'
      });
      return _react.default.createElement("div", {
        ref: function ref(node) {
          _this2._container = node;
        },
        className: classes
      }, _react.default.createElement("div", {
        className: "FormElement-control"
      }, _react.default.createElement(_TextInput.default, (0, _extends2.default)({
        key: inputKey,
        ref: function ref(node) {
          _this2._input = node;
        }
      }, textInputProps, {
        additionalInputProps: newAdditionalInputProps,
        defaultValue: value,
        onChange: this._onInputChange,
        onFocus: this._onInputFocus,
        onBlur: this._onInputBlur
      })), _react.default.createElement(_AutoSuggestList.default, {
        hidden: suggestionsHidden,
        suggestions: suggestions || [],
        activeSuggestion: activeSuggestion,
        suggestionBoxFooter: suggestionBoxFooter,
        onSuggestionSelect: this._onSelectSuggestion,
        onSuggestionMouseDown: this._onSuggestionMouseDown,
        onSuggestionMouseOut: this._onSuggestionMouseOut
      }), value && _react.default.createElement(_Button.default, {
        className: "AutoSuggestInput-clear",
        onClick: this._onClear
      }, _react.default.createElement(_Icon.default, {
        name: "times-circle"
      }))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "node",
    get: function get() {
      return this._input.node;
    }
  }]);
  return AutoSuggestInput;
}(_react.Component);

exports.default = AutoSuggestInput;
(0, _defineProperty2.default)(AutoSuggestInput, "propTypes", (0, _objectSpread2.default)({}, _TextInputPropTypes.default, {
  /** Whether or not to highlight the first suggestion in the list when suggestions are presented. */
  autoActivateFirstSuggest: _propTypes.default.bool,

  /** The available suggestions. */
  suggestions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  })),

  /** A custom element to display at the bottom of the suggestion list */
  suggestionBoxFooter: _propTypes.default.element,

  /** Function to execute when a suggestion is selected. */
  onSuggestionSelect: _propTypes.default.func.isRequired,

  /** Optional function to execute when input field is cleared. */
  onClear: _propTypes.default.func
}));
(0, _defineProperty2.default)(AutoSuggestInput, "defaultProps", {
  iconPosition: 'left',
  name: 'search',
  placeholder: 'Search',
  suggestions: []
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(AutoSuggestInput, "AutoSuggestInput", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/AutoSuggestInput/AutoSuggestInput.jsx");
  leaveModule(module);
})();

;